<div class="container mt-4">
  <div *ngIf="!paymentMode" class="row">
    <div *ngIf="hideActions" class="col-sm-2">
      <div class="card-body">
        <div class="form-check">
          <input class="form-check-input"  (change)="onChangeActiveFilter($event.target.value)"type="radio" name="RadioActiveFilter" id="Option1" value="1" checked>
          <label class="form-check-label" for="Option1">
            Activos
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" (change)="onChangeActiveFilter($event.target.value)" type="radio" name="RadioActiveFilter" id="Option2" value="2">
          <label class="form-check-label" for="Option2">
            Inactivos
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" (change)="onChangeActiveFilter($event.target.value)" type="radio" name="RadioActiveFilter" id="Option3" value="0">
          <label class="form-check-label" for="Option3">
            Todos
          </label>
        </div>
      </div>
      <div class="card-footer mb-3">
        <div class="btn-group d-flex">
          <button class="btn btn-success w-100" [routerLink]="['/exams/add']">Agregar</button>
        </div>
      </div>
    </div>
    <div class="col sm-7">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col" class="p-1 align-middle text-center d-none d-lg-table-cell">Id</th>
            <th scope="col" class="p-1 align-middle text-center">Nombre</th>
            <th scope="col" class="p-1 align-middle text-center d-none d-lg-table-cell">Precio</th>
            <th scope="col" *ngIf="hideActions" class="p-1 align-middle text-center d-none d-lg-table-cell">Número de preguntas</th>
            <th scope="col" *ngIf="hideActions" class="p-1 align-middle text-center d-none d-lg-table-cell">Nivel</th>
            <th scope="col" *ngIf="hideActions" class="p-1 align-middle text-center d-none d-lg-table-cell">Clasificación</th>
            <th scope="col" *ngIf="hideActions" class="p-1 align-middle text-center">Activo</th>
            <th scope="col" *ngIf="hideActions" class="p-1 align-middle text-center">Lectura</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let exam of exams" class="p-0">
            <th scope="row" class="p-0 align-middle text-center d-none d-lg-table-cell">{{exam.idExams}}</th>
            <td class="p-0 align-middle">{{exam.Name}}</td>
            <td class="p-0 align-middle text-center d-none d-lg-table-cell">${{exam.Price}}.00</td>
            <td *ngIf="hideActions" class="p-0 align-middle text-center d-none d-lg-table-cell">{{exam.QuestionNumber}}</td>
            <td *ngIf="hideActions" class="p-0 align-middle text-center d-none d-lg-table-cell">{{exam.LevelName}}</td>
            <td *ngIf="hideActions" class="p-0 align-middle text-center d-none d-lg-table-cell">{{exam.ClassificationName}}</td>
            <td *ngIf="hideActions" class="p-0 align-middle text-center"><input class="m-0 form-check-input" type="checkbox" [checked]=exam.Active disabled></td>
            <td *ngIf="hideActions" class="p-0 align-middle text-center">{{exam.HasReading?'Si':'No'}}</td>
            <td class="p-0 align-middle">
              <div class="btn-group d-flex">
                <!-- <button class="btn btn-outline-primary w-100" [routerLink]="['/payment']" [state]="{Price: 10}" routerLinkActive="router-link-active" ><i class="fa fa-paypal"></i></button> -->
                <button class="btn btn-outline-primary w-100" (click)="paymentToggle(exam.idExams)"><i class="fa fa-paypal"></i></button>
                <button *ngIf="hideActions" class="btn btn-outline-primary w-100" [routerLink]="['/exams/edit/', exam.idExams]" routerLinkActive="router-link-active" ><i class="fa fa-pencil"></i></button>
                <button *ngIf="hideActions" class="btn btn-outline-info w-100" [routerLink]="['/exams/detail/', exam.idExams]" routerLinkActive="router-link-active" ><i class="fa fa-info"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="paymentMode">
    <div class="row justify-content-center">
      <div>
          <app-paypal [idExam]="selectedIdExam" [Type]="1" (cancelPayment)="cancelPaymentMode($event)"></app-paypal>
      </div>
    </div>
  </div>
</div>
